import { TrendingUp } from 'lucide-react';

const cases = [
  {
    name: "Bright Smile Dental Clinic",
    location: 'London, UK',
    metric: '3x',
    metricLabel: 'Patient Increase',
    before: '15 patients/day',
    after: '45 patients/day',
    services: ['Website + SEO', 'Google Business', 'Social Media'],
  },
  {
    name: 'ClearVision Eye Center',
    location: 'Toronto, Canada',
    metric: '4.8',
    metricLabel: 'Google Rating (from 2.8)',
    before: '2.8 Rating',
    after: '4.8 Rating',
    services: ['Reputation Management', 'Social Media', 'Review Growth'],
  },
  {
    name: 'Summit Ortho Partners',
    location: 'New York, USA',
    metric: '25x',
    metricLabel: 'Web Traffic Growth',
    before: '100 monthly visits',
    after: '2,500 monthly visits',
    services: ['Website + SEO', 'AI Engagement', 'Paid Ads'],
  },
];

const CaseStudies = () => (
  <section id="case-studies" className="bg-[#EDE7D9] py-20 lg:py-28" data-testid="case-studies-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-14">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#8C6330] mb-4">Results That Speak</p>
        <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight text-[#11181C]">
          Real Growth for Real Clinics
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {cases.map((c, i) => (
          <div
            key={c.name}
            className="bg-white border border-[#D6CEBF] rounded-2xl p-7 shadow-sm hover:shadow-lg transition-all duration-300 service-card"
            data-testid={`case-study-${i}`}
          >
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 rounded-xl bg-[#D4E4DA] flex items-center justify-center">
                <TrendingUp size={20} className="text-[#1B3F33]" />
              </div>
              <div>
                <h3 className="font-heading text-base font-medium text-[#11181C]">{c.name}</h3>
                <p className="text-xs text-[#4A5568]">{c.location}</p>
              </div>
            </div>

            <div className="bg-[#D4E4DA] rounded-xl p-5 mb-5 text-center">
              <p className="font-heading text-4xl font-semibold text-[#1B3F33]">{c.metric}</p>
              <p className="text-sm text-[#4A5568] mt-1">{c.metricLabel}</p>
            </div>

            <div className="grid grid-cols-2 gap-3 mb-5">
              <div className="bg-[#F9F7F2] rounded-lg p-3">
                <p className="text-[10px] uppercase tracking-wider text-[#8C6330] font-bold">Before</p>
                <p className="text-sm font-medium text-[#11181C] mt-1">{c.before}</p>
              </div>
              <div className="bg-[#F9F7F2] rounded-lg p-3">
                <p className="text-[10px] uppercase tracking-wider text-[#265E4A] font-bold">After</p>
                <p className="text-sm font-medium text-[#11181C] mt-1">{c.after}</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              {c.services.map((s) => (
                <span key={s} className="text-xs bg-[#EDE7D9] text-[#4A5568] px-3 py-1 rounded-full">{s}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CaseStudies;
